<template>
  <div class="error404">
    <div class="error404-body-con">
      <div class="error404-body-con-title secondary--text">
        4<span><v-icon size="inherit" color="warning">mdi-compass-outline</v-icon></span>4
      </div>
      <p class="error404-body-con-message info--text">{{label("message")}}</p>
    </div>
    <v-container justify-center>
      <v-row justify="center">
        <v-col cols="3">
          <ActionButton type="link" to="/">
            {{label("top")}}
          </ActionButton>
        </v-col>
        <v-col cols="3">
          <ActionButton type="cancel" @click="back()">
            {{label("back")}}
          </ActionButton>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import ActionButton from "../../molecules/ActionButton";
  import ComponentMixin from "../../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "page",
    name: "Error404Page",
    components: {ActionButton}
  }
</script>

<style scoped lang="sass">
  @keyframes error404animation
    0%
      transform: rotateZ(0deg)
    20%
      transform: rotateZ(-60deg)
    40%
      transform: rotateZ(-10deg)
    60%
      transform: rotateZ(50deg)
    80%
      transform: rotateZ(-20deg)
    100%
      transform: rotateZ(0deg)

  .error404
    &-body-con
       width: 700px
       height: 350px
       margin: 0 auto
       &-title
          text-align: center
          font-size: 240px
          font-weight: 700
          height: 260px
          line-height: 260px
          margin-top: 40px
          span
            display: inline-block
            font-size: 230px
            animation: error404animation 3s ease 0s infinite alternate
       &-message
          display: block
          text-align: center
          font-size: 30px
          font-weight: 500
          letter-spacing: 12px
</style>